<template>
  <RemotePaginatedList :filter-options="filterOptions"
                       :headers="headers"
                       data-url="admin/sor/items/"
                       data-key="items"
                       :extra-params="{sor_id: sorId, ...extraParams}"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       :item-per-page.sync="itemPerPage"
                       :current-page.sync="currentPage"
                       :extra-filters="extraFilters"
                       v-bind="$attrs"
                       class="item-search-list">
    <template #item.item_no="{item}">
      {{
        item.item_group.sub_sub_section.sub_section.section.order_no.toString().padStart(2, '0')
      }}{{ item.item_group.item_prefix }}{{ item.category ? item.category.suffix : 'A' }}
    </template>
    <template #item.item_group.printed_description="{item, index}">
      <v-container fluid class="pa-0">
        <v-row>
          <v-col cols="11">
            <v-container fluid class="px-0 item-search-list-description">
              <v-row no-gutters>
                <v-col cols="12" class="font-weight-bold">
                  S{{ item.item_group.sub_sub_section.sub_section.section.order_no.toString().padStart(2, '0') }}
                  {{ item.item_group.sub_sub_section.sub_section.section.name }}
                </v-col>
                <v-col cols="12"
                       v-html="replaceItemNo(item, item.item_group.sub_sub_section.sub_section.descriptions)"></v-col>
                <v-col cols="12"
                       v-html="replaceItemNo(item, item.item_group.full_description || item.item_group.printed_description)"></v-col>
                <v-col cols="12" v-if="item.category"
                       v-html="JSON.parse(item.category.definition).join('; ')">

                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col cols="1" class="align-self-center">
            <v-btn icon
                   color="primary"
                   @click="onItemDetailClick(item, index)">
              <v-icon large>mdi-information-outline</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>

    </template>
    <template #item.unit="{item}">
      {{ $processedUnit(item.item_group.sub_sub_section.unit) }}
    </template>
    <template #item.value="{item}">
      {{ $parseCurrency(item.value) }}
    </template>
    <template #item.actions="{item, index}">
      <v-btn color="primary"
             text
             @click="onAddClicked(item, index)">
        Add
      </v-btn>
    </template>
  </RemotePaginatedList>
</template>

<script>
import {onMounted, ref, watch} from '@vue/composition-api'
import RemotePaginatedList from "../RemotePaginatedList";
import SorItemDetailDialog from "@/components/sor/SorItemDetailDialog";
import {computed} from "@vue/composition-api/dist/vue-composition-api";
import _ from "lodash";

export default {
  name: 'ItemSearchList',
  components: {RemotePaginatedList},
  props: {
    workOrder: Object,

    sorId: String,
    sorName: String,
    extraParams: Object,
    extraFilters: Object,
    refreshTrigger: Boolean,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh(false);
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh(true);
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const filterOptions = ref([])

    // Data Table
    const headers = ref([
      {text: root.$t('item.item_no'), value: 'item_no', width: 150},
      {text: root.$t('item.descriptions'), value: 'item_group.printed_description'},
      {text: root.$t('item.unit'), value: 'unit', width: 100},
      {text: root.$t('item.rate'), value: 'value', width: 100},
      {text: '', value: 'actions', sortable: false, width: 50},
    ]);
    const innerRefreshTrigger = ref(false);

    const replaceItemNo = function (item, str) {
      return str.replaceAll(/({{[0-9]+}})/g, (match) => {
        let withoutBrackets = match.replace('{{', '').replace('}}', '')

        return `${item.item_group.sub_sub_section.sub_section.section.order_no.toString().padStart(2, '0')}${withoutBrackets.padStart(3, '0')}`
      })
    };

    const itemPerPage = ref(10);
    const currentPage = ref(1);
    const onItemDetailClick = async function (item, idx) {
      const result = await root.$dialog.showAndWait(SorItemDetailDialog, {
        // showClose: false,
        persistent: true,
        width: '90vw',

        workOrder: props.workOrder,

        itemId: item.id,
        itemIndex: itemPerPage.value * (currentPage.value - 1) + idx + 1,
        queryParams: {
          sor_id: props.sorId,
          filters: props.extraFilters,
          ...props.extraParams,
        },
        sorName: props.sorName,
      });

      if (result) {
        emit('add', result);
      }
    }
    const onAddClicked = function (item, idx) {
      // console.log(item, itemPerPage.value, currentPage.value, idx, itemPerPage.value * (currentPage.value - 1) + idx + 1);

      emit('add', item);
    }

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,

      replaceItemNo,

      itemPerPage,
      currentPage,

      onItemDetailClick,
      onAddClicked,
    }
  }
}
</script>

<style lang="less">
.item-search-list {
  .item-search-list-description {
    table {
      font-size: 100%;
      border-collapse: collapse;

      td {
        border: solid 1px black;
        padding: 1px;
      }
    }
  }
}
</style>
